// Marks an error whose message is already meant for the user (translated, no
// protocol jargon). The device modals show these as they are and replace every
// other error with a generic message.
export const userError = (message) =>
  Object.assign(new Error(message), { userFacing: true })

// Rete di sicurezza sul gateway seriale, che in alcuni casi non risponde mai
// (nessuna porta seriale nel sistema, chiusura della porta fallita). Il suo
// timeout interno arriva a ~41 s (20 s più un secondo tentativo), quindi questo
// scatta solo quando la risposta non arriverà più.
const SERIAL_TIMEOUT = 60000

export const withSerialTimeout = (promise) =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(
      () =>
        reject(
          Object.assign(new Error('Serial gateway did not answer'), {
            code: 'TIMEOUT',
          })
        ),
      SERIAL_TIMEOUT
    )
    promise.then(resolve, reject).finally(() => clearTimeout(timer))
  })

// Il gateway seriale rifiuta con { result: { message } }, quasi sempre in
// inglese tecnico e non tradotto. Restituisce { status } per i casi che si
// risolvono con Riprova (gli stessi stati del BLE), altrimenti { error } da
// mostrare.
export function serialFailure(err, t) {
  const result = (err && err.result) || {}
  const message = result.message || ''

  // Gli errori di un dispositivo che ha risposto portano la porta; senza porta
  // è il timeout del gateway (o nessuna porta seriale): non ha risposto nessuno.
  // Il testo non serve a riconoscerlo: dipende dal comando ed è a volte tradotto
  // ("Init error", "Cannot find any active device…").
  if ((err && err.code === 'TIMEOUT') || (err && err.result && !result.port))
    return { error: userError(t('app.common.deviceNotFound')) }

  if (message.startsWith('Device found, wrong screen'))
    return { status: 'wrongScreen' }
  if (message.startsWith('Data are not ready')) return { status: 'notReady' }

  // 'Init error…': un dispositivo c'è ma risponde in modo inatteso.
  if (!message || message.startsWith('Init error')) return { error: err }

  // Il resto passa dall'i18n del main process (es. "Disconnect USB cable…").
  return { error: userError(message) }
}
